import { render, staticRenderFns } from "./ReleaseDateModal.vue?vue&type=template&id=0b30a7c9"
import script from "./ReleaseDateModal.vue?vue&type=script&lang=js"
export * from "./ReleaseDateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports